import React, {ReactElement} from "react";
import {Box, ButtonBase, SvgIcon, Typography, useMediaQuery, useTheme} from "@mui/material";
import {PD_MD, PD_XLG} from "shared/dimens";
import {Outlet} from "react-router-dom";
import {TabsContainer, TabsContainerProps, TabsContainerState} from "shared/TabsContainer";
import {StyledBoxRow} from "shared/StyledComponents";

export type ProfileTabsContainerProps<TAB_TYPE> = TabsContainerProps<TAB_TYPE> & {
  iconHeader?: boolean,
  headerLink?: string,
  accessory?: ReactElement,
}

export type ProfileTabsContainerState<TAB_TYPE> = TabsContainerState<TAB_TYPE> & {
  selectedTab: TAB_TYPE,
}

function TabView(props: { tabKey: string, text: string, iconType: typeof SvgIcon, selected?: boolean }) {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  return <>
    {md
      ? <Typography style={{fontSize: "144%", fontWeight: "bold"}}>{props.text}</Typography>
      : <props.iconType style={{width: 32, height: 32}}/>}
    {props.selected
      ?
      <div style={{position: "absolute", width: "100%", height: 4, bottom: 0, background: theme.palette.primary.main}}/>
      : null}
  </>;
}

function ProfileBar<TAB_TYPE>(props: {
  tabPath: string,
  iconHeader?: boolean,
  headerLink?: string
} & TabsContainerProps<TAB_TYPE>) {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));
  return <StyledBoxRow style={{
    boxSizing: "border-box",
    flexShrink: 0,
    height: 72,
    paddingLeft: props.iconHeader ? 0 : PD_MD,
    paddingRight: PD_MD,
    gap: PD_XLG,
    justifyContent: "center",
  }}>
    {TabsContainer.expandGroups(props.tabs).items.filter(tab => !tab.hidden).map(tab => {
      return <ButtonBase
        style={{position: "relative", display: "flex", flexBasis: 0, flexGrow: 1}}
        onClick={() => props.path.navigate(tab.path)}>
        <TabView tabKey={tab.path} text={tab.text} iconType={tab.iconType} selected={tab.path === props.tabPath}/>
      </ButtonBase>;
    })}
  </StyledBoxRow>;
}

export abstract class ProfileTabsContainer<TAB_TYPE, P extends ProfileTabsContainerProps<TAB_TYPE>, S extends ProfileTabsContainerState<TAB_TYPE>> extends TabsContainer<TAB_TYPE, P, S> {

  render() {
    return <Box
      style={{display: "flex", flexGrow: 1, flexDirection: "column", position: "relative", overflowX: "hidden"}}>
      <ProfileBar path={this.props.path}
                  iconHeader={this.props.iconHeader}
                  headerLink={this.props.headerLink}
                  tabs={this.props.tabs}
                  tabPath={this.state.tabPath}/>
      <Outlet/>
    </Box>
  }
}
